(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionUpdateController', ProductOptionUpdateController);

    ProductOptionUpdateController.$inject = ['$state', 'notificationSrvc', 'productOptionDataSrvc', 'productOptionMessagesConst', 'productOptionGroupDataSrvc', 'productOptionTechLineDataSrvc', 'checkModelPermissionsSrvc', 'techlinePermissionsConst', 'errorNotificationSrvc'];

    function ProductOptionUpdateController($state, notificationSrvc, productOptionDataSrvc, productOptionMessagesConst, productOptionGroupDataSrvc, productOptionTechLineDataSrvc, checkModelPermissionsSrvc, techlinePermissionsConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            label_pl: [],
            label_en: [],
            label_de: [],
            label_cpde: [],
            label_cpen: [],
            description_pl: [],
            description_de: [],
            description_en: [],
            description_cpde: [],
            description_cpen: [],
            thickness: [],
            hidden_price: [],
            realization_days: [],
            enter_values_possible: [],
            group_together: [],
            tech_line: [],
            confirm_choice: [],
            show_on_production: [],
            statement_pl: [],
            statement_de: [],
            statement_en: [],
            statement_cpde: [],
            statement_cpen: [],
            options_group: [],
            image: [],
            show_in_inteligent_filter: [],
            applies_to_custom_format: [],
            custom_format_dimension: [],
            internal_description: []
        };
        self.optionData = {
            label_pl: '',
            label_en: '',
            label_de: '',
            label_cpde: '',
            label_cpen: '',
            description_pl: '',
            description_de: '',
            description_en: '',
            description_cpde: '',
            description_cpen: '',
            thickness: '',
            hidden_price: false,
            realization_days: '',
            enter_values_possible: false,
            group_together: false,
            tech_line: false,
            confirm_choice: false,
            show_on_production: false,
            min_value: 0,
            max_value: 0,
            options_group: '',
            show_in_inteligent_filter: false,
            image: null,
            applies_to_custom_format: false,
            custom_format_dimension: null,
            internal_description: ''
        };

        self.techLineObjectServerErrors = {
            start_x: [],
            start_y: [],
            end_x: [],
            end_y: [],
            image: []
        };
        self.techLineObjectData = {
            start_x: 0.0,
            start_y: 0.0,
            end_x: 0.0,
            end_y: 0.0,
            image: undefined
        };

        self.customFormatDimensionChoices = [];

        self.hasTechLineAddPermission = hasTechLineAddPermission;
        self.hasTechLineUpdatePermission = hasTechLineUpdatePermission;
        self.hasTechLineViewPermission = hasTechLineViewPermission;

        self.updateOption = updateOption;
        self.cleanErrors = cleanErrors;

        self.onAppliesToCustomFormatChange = onAppliesToCustomFormatChange;
        self.onEnterValuesPossibleChange = onEnterValuesPossibleChange;

        activate();

        function activate() {
            getOption();
            getCustomFormatDimensionChoices();
        }

        function getOption() {
            return productOptionDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.optionData = response;

                if (self.optionData.tech_line_object) {
                    self.techLineObjectData = self.optionData.tech_line_object;
                }

                getGroupName(self.optionData.options_group);
                delete self.optionData.date_modified;
                delete self.optionData.date_added;
                delete self.optionData.last_modified_by;
                return response;
            });
        }

        function getGroupName(pk) {
            return productOptionGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name_pl;
            });
        }

        function hasTechLineAddPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                techlinePermissionsConst.add);
        }

        function hasTechLineUpdatePermission() {
            return !checkModelPermissionsSrvc.isDenied(
                techlinePermissionsConst.update);
        }

        function hasTechLineViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                techlinePermissionsConst.view);
        }

        function updateOption() {
            productOptionDataSrvc.update({
                pk: self.optionData.pk
            }, self.optionData).$promise.then(
                function(response) {
                    var techLinePromise;
                    self.techLineObjectData.option = response.pk;

                    if (self.techLineObjectData.pk) {
                        if (!hasTechLineAddPermission()) {
                            notificationSrvc.notification("error", techlinePermissionsConst.update.errorMsg);
                            return;
                        }
                        techLinePromise = productOptionTechLineDataSrvc.update({
                            pk: self.techLineObjectData.pk
                        }, self.techLineObjectData).$promise;
                    } else {
                        if (!hasTechLineAddPermission()) {
                            notificationSrvc.notification("error", techlinePermissionsConst.add.errorMsg);
                            return;
                        }
                        techLinePromise = productOptionTechLineDataSrvc.create(
                            self.techLineObjectData).$promise;
                    }

                    techLinePromise.then(
                        function(techLineResponse) {
                            notificationSrvc.notification("success", productOptionMessagesConst.update);
                            $state.go('layout.productOptionGroup.list');
                        },
                        function(response) {
                            errorNotificationSrvc.displayErrors(response.data);
                            self.techLineObjectServerErrors = response.data;
                        }
                    );
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(object, key) {
            object[key] = [];
        }

        function getCustomFormatDimensionChoices() {
            productOptionDataSrvc.adminKindOptions().$promise.then(
                function (response) {
                    self.customFormatDimensionChoices = response;
                }
            );
        }

        function onAppliesToCustomFormatChange() {
            self.optionData.custom_format_dimension = null;
        }

        function onEnterValuesPossibleChange() {
            self.optionData.applies_to_custom_format = false;
            self.optionData.custom_format_dimension = null;
        }
    }
})();
